import React from 'react';

import ListTrendType from './List';
import useTrendingType from './useTrendingType';

const TrendingType: React.FC = () => {
  const {
    topViewList,
    topArtList,
    topPFPsList,
    topGameList,
    urlArtCategory,
    urlGamingCategory,
    urlPFPsCategory,
  } = useTrendingType();

  return (
    <div className="bg-white px-[40px] py-10 md:px-[20px]">
      <ListTrendType list={topViewList} title="Popular Artworks" />
      <ListTrendType list={topArtList} title="Trending in Art" urlCategory={urlArtCategory} />
      <ListTrendType
        list={topGameList}
        title="Trending in Gaming"
        urlCategory={urlGamingCategory}
      />
      <ListTrendType list={topPFPsList} title="Trending in PFPs" urlCategory={urlPFPsCategory} />
    </div>
  );
};

export default TrendingType;
